/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiIdpQueueAssignQueuePost } from '../fn/idp-queue/api-idp-queue-assign-queue-post';
import { ApiIdpQueueAssignQueuePost$Params } from '../fn/idp-queue/api-idp-queue-assign-queue-post';
import { apiIdpQueueAssignQueuePost$Plain } from '../fn/idp-queue/api-idp-queue-assign-queue-post-plain';
import { ApiIdpQueueAssignQueuePost$Plain$Params } from '../fn/idp-queue/api-idp-queue-assign-queue-post-plain';
import { apiIdpQueueCleanupExpiredQueuePost } from '../fn/idp-queue/api-idp-queue-cleanup-expired-queue-post';
import { ApiIdpQueueCleanupExpiredQueuePost$Params } from '../fn/idp-queue/api-idp-queue-cleanup-expired-queue-post';
import { apiIdpQueueNextQueueItemGet } from '../fn/idp-queue/api-idp-queue-next-queue-item-get';
import { ApiIdpQueueNextQueueItemGet$Params } from '../fn/idp-queue/api-idp-queue-next-queue-item-get';
import { apiIdpQueueNextQueueItemGet$Plain } from '../fn/idp-queue/api-idp-queue-next-queue-item-get-plain';
import { ApiIdpQueueNextQueueItemGet$Plain$Params } from '../fn/idp-queue/api-idp-queue-next-queue-item-get-plain';
import { AssignQueueResponse } from '../models/assign-queue-response';
import { NextQueueItemResponse } from '../models/next-queue-item-response';

@Injectable({ providedIn: 'root' })
export class IdpQueueService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiIdpQueueAssignQueuePost()` */
  static readonly ApiIdpQueueAssignQueuePostPath = '/api/IdpQueue/assign-queue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpQueueAssignQueuePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpQueueAssignQueuePost$Plain$Response(params?: ApiIdpQueueAssignQueuePost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignQueueResponse>> {
    return apiIdpQueueAssignQueuePost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpQueueAssignQueuePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpQueueAssignQueuePost$Plain(params?: ApiIdpQueueAssignQueuePost$Plain$Params, context?: HttpContext): Observable<AssignQueueResponse> {
    return this.apiIdpQueueAssignQueuePost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignQueueResponse>): AssignQueueResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpQueueAssignQueuePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpQueueAssignQueuePost$Response(params?: ApiIdpQueueAssignQueuePost$Params, context?: HttpContext): Observable<StrictHttpResponse<AssignQueueResponse>> {
    return apiIdpQueueAssignQueuePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpQueueAssignQueuePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiIdpQueueAssignQueuePost(params?: ApiIdpQueueAssignQueuePost$Params, context?: HttpContext): Observable<AssignQueueResponse> {
    return this.apiIdpQueueAssignQueuePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<AssignQueueResponse>): AssignQueueResponse => r.body)
    );
  }

  /** Path part for operation `apiIdpQueueNextQueueItemGet()` */
  static readonly ApiIdpQueueNextQueueItemGetPath = '/api/IdpQueue/next-queue-item';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpQueueNextQueueItemGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueNextQueueItemGet$Plain$Response(params?: ApiIdpQueueNextQueueItemGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<NextQueueItemResponse>> {
    return apiIdpQueueNextQueueItemGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpQueueNextQueueItemGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueNextQueueItemGet$Plain(params?: ApiIdpQueueNextQueueItemGet$Plain$Params, context?: HttpContext): Observable<NextQueueItemResponse> {
    return this.apiIdpQueueNextQueueItemGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<NextQueueItemResponse>): NextQueueItemResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpQueueNextQueueItemGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueNextQueueItemGet$Response(params?: ApiIdpQueueNextQueueItemGet$Params, context?: HttpContext): Observable<StrictHttpResponse<NextQueueItemResponse>> {
    return apiIdpQueueNextQueueItemGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpQueueNextQueueItemGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueNextQueueItemGet(params?: ApiIdpQueueNextQueueItemGet$Params, context?: HttpContext): Observable<NextQueueItemResponse> {
    return this.apiIdpQueueNextQueueItemGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<NextQueueItemResponse>): NextQueueItemResponse => r.body)
    );
  }

  /** Path part for operation `apiIdpQueueCleanupExpiredQueuePost()` */
  static readonly ApiIdpQueueCleanupExpiredQueuePostPath = '/api/IdpQueue/cleanup-expired-queue';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiIdpQueueCleanupExpiredQueuePost()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueCleanupExpiredQueuePost$Response(params?: ApiIdpQueueCleanupExpiredQueuePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiIdpQueueCleanupExpiredQueuePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiIdpQueueCleanupExpiredQueuePost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiIdpQueueCleanupExpiredQueuePost(params?: ApiIdpQueueCleanupExpiredQueuePost$Params, context?: HttpContext): Observable<void> {
    return this.apiIdpQueueCleanupExpiredQueuePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
